import { GetStaticProps } from "next";

import { SearchView, SearchViewProps } from "@temp/views/Search";
import { getSearchStaticProps } from "@utils/ssr";

export const getStaticProps: GetStaticProps<
  SearchViewProps,
  SearchViewProps["params"]
> = async (props) => getSearchStaticProps(props);

export default SearchView;
